import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

// firebase init
const firebaseConfig = {
  apiKey: "AIzaSyDqV8lDj3qF0e9d9QAaxsC_vXyGV9yHr88",
  authDomain: "plantiapp-c67eb.firebaseapp.com",
  databaseURL: "https://plantiapp-c67eb.firebaseio.com",
  projectId: "plantiapp-c67eb",
  storageBucket: "plantiapp-c67eb.appspot.com",
  messagingSenderId: "921828526876",
  appId: "1:921828526876:web:6bdc571f30f72c8104c8d9",
  measurementId: "G-EF0SP5BFPJ"
}
firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()
const auth = firebase.auth()

// collections
const anunciosCollection = db.collection('anuncios')
const publicData = db.collection('public_data')
const usersCollection = db.collection('users_staff')

// export utils/refs
export {
  firebase,
  db,
  auth,
  anunciosCollection,
  usersCollection,
  publicData
}
